module.exports = __webpack_public_path__ + "static/media/ciniphilia_ang_platform.6edec138.gif";